import React, { FC } from 'react'
import { DropdownMenuItem } from './Item/types'
import DropdownMenu from './DropdownMenu'
import { MenuTrigger, Wrapper } from './ContextMenu.styles'

export const ContextMenu: FC<{ items: DropdownMenuItem[]; onMenuClick?: () => void }> = ({
  items,
  onMenuClick
}) => {
  return (
    <Wrapper onClick={e => e.stopPropagation()}>
      <DropdownMenu items={items} onMenuClick={onMenuClick}>
        <MenuTrigger />
      </DropdownMenu>
    </Wrapper>
  )
}
